// Swimlanes. Projects keep a single ordered list; a group is just a label on each project.
// The board shows named groups in the order they first appear, with ungrouped projects last.

export const NO_GROUP_LABEL = 'No group';

export function hasGroups(projects) {
  return (projects || []).some((p) => p.group);
}

export function groupNames(projects) {
  const seen = [];
  for (const p of projects || []) if (p.group && !seen.includes(p.group)) seen.push(p.group);
  return seen;
}

export function groupRows(projects, collapsed = new Set()) {
  const list = projects || [];
  if (!hasGroups(list)) return list.map((project, index) => ({ type: 'project', key: project.id, project, index, group: '' }));
  const buckets = new Map();
  list.forEach((project, index) => {
    const g = project.group || '';
    if (!buckets.has(g)) buckets.set(g, []);
    buckets.get(g).push({ project, index });
  });
  const order = groupNames(list);
  if (buckets.has('')) order.push('');
  const rows = [];
  for (const g of order) {
    const items = buckets.get(g);
    const isCollapsed = collapsed.has(g);
    rows.push({ type: 'group', key: `group:${g}`, group: g, name: g || NO_GROUP_LABEL, count: items.length, collapsed: isCollapsed, projects: items.map((i) => i.project) });
    if (!isCollapsed) for (const { project, index } of items) rows.push({ type: 'project', key: project.id, project, index, group: g });
  }
  return rows;
}

/**
 * Translate a drop position in the displayed rows (0 = above the first row) into
 * where the project goes in the underlying list and which group it joins.
 */
export function dropTarget(rows, to) {
  const above = rows[to - 1];
  const below = rows[to];
  const grouped = rows.some((r) => r.type === 'group');
  if (!grouped) {
    if (below?.type === 'project') return { beforeId: below.project.id, group: undefined };
    return { beforeId: null, afterId: above?.project?.id ?? null, group: undefined };
  }
  if (!above) {
    const first = rows[0];
    return { beforeId: first?.projects?.[0]?.id ?? null, group: first?.group ?? '' };
  }
  if (above.type === 'project') return { afterId: above.project.id, group: above.group };
  if (above.collapsed) return { afterId: above.projects[above.projects.length - 1]?.id ?? null, group: above.group };
  return { beforeId: above.projects[0]?.id ?? null, group: above.group };
}
